import { InjectionToken } from '@angular/core';

import type { ClientEnvironment } from '~app-client/core/types';

export const CLIENT_ENVIRONMENT = new InjectionToken<ClientEnvironment>('CLIENT_ENVIRONMENT');
